import React from 'react';

import { PromotionalBanner } from '../../../../../../components/promotional-banner';
import { useManageSubscriptionDrawerContext } from '../../../context/manage-subscription-drawer-context';
import { PendingSubscriptionChangeBanner } from '../../../pending-subscription-change-banner';
import { useDoesSellerHavePromotionalOffer } from '../../migrate-plan-modal/hooks/use-does-seller-have-promotional-offer';
import { useManageSubscriptionDrawerSectionVisibility, PlanGridConfig } from '../use-manage-subscription-drawer-section-visibility';
import { messages } from '../messages';
import styles from '../styles.module.css';

export const SubscriptionDrawerTopBanners = () => {
  const { shouldShowTrialAutoConvertedToFreeBanner } = useManageSubscriptionDrawerContext();
  const hasActivePromotion = useDoesSellerHavePromotionalOffer();
  const { planGridConfig } = useManageSubscriptionDrawerSectionVisibility();
  const shouldShowPendingChangeBanner = planGridConfig !== PlanGridConfig.StandardLegacy;

  return (
    <>
      {hasActivePromotion && (
        <PromotionalBanner
          className={styles['drawer-banner']}
          promotionalHeaderMessage={messages.upgradePromotionHeader}
          promotionalSubheaderMessage={messages.upgradePromotionSubheader}
        />
      )}

      {shouldShowTrialAutoConvertedToFreeBanner ? (
        <PromotionalBanner
          className={styles['drawer-banner']}
          promotionalHeaderMessage={messages.trialExpiredBannerHeader}
          promotionalSubheaderMessage={messages.trialExpiredBannerSubheader}
        />
      ) : null}
      {shouldShowPendingChangeBanner ? <PendingSubscriptionChangeBanner className={styles['drawer-banner']} /> : null}
    </>
  );
};
